/* Copyright (c) 2023 Xperi. All Rights Reserved. */
/* eslint-disable global-require */
/* eslint-disable import/no-dynamic-require */

import { AppUtils } from '../AppUtils';

export class Branding {
    private static brandingMap: { [key: string]: any; appImages: { imageUrl: string }[] } = {
        appImages: [],
    };

    public static setFallbackBrandings = (locale: string, msoName?: string) => {
        const localeArr = locale.split('_');
        const language = localeArr[0].toLowerCase();
        const region = localeArr[1].toLowerCase();
        const msoNameLowerCase = msoName?.toLowerCase();
        let languageFile = {};
        let regionLanguageFile = {};
        let msoLanguageFile = {};

        // load default branding file.
        try {
            Branding.brandingMap = require('../../assets/brandings/en_any_any_unmanaged_smarttv.json');
        } catch (err) {
            // Do Nothing
        }

        // load language file
        try {
            languageFile = require(
                `../../assets/brandings/${language}_any_any_unmanaged_smarttv.json`,
            );
        } catch (err) {
            // Do Nothing
        }

        // load regionLanguage file
        try {
            regionLanguageFile = require(
                `../../assets/brandings/${language}_${region}_any_unmanaged_smarttv.json`,
            );
        } catch (err) {
            // Do Nothing
        }

        // load msoLanguage file
        try {
            msoLanguageFile = require(
                `../../assets/brandings/${language}_${region}_${msoNameLowerCase}_unmanaged_smarttv.json`,
            );
        } catch (err) {
            // Do Nothing
        }
        Branding.brandingMap = AppUtils.mergeObjects(Branding.brandingMap, languageFile);
        Branding.brandingMap = AppUtils.mergeObjects(Branding.brandingMap, regionLanguageFile);
        Branding.brandingMap = AppUtils.mergeObjects(Branding.brandingMap, msoLanguageFile);

        if (Branding.brandingMap.appImages) {
            Branding.brandingMap.appImages.forEach((appImage: any) => {
                import(`../../assets${appImage.imageUrl}`)
                    .then((image) => {
                        // eslint-disable-next-line no-param-reassign
                        appImage.sourceUrl = image.default;
                    })
                    // eslint-disable-next-line no-unused-vars
                    .catch((err) => {
                        // Do Nothing
                    });
            });
        }
    };

    public static getFallbackBrandingUiInfoForKey = (key: string): string => {
        return Branding.brandingMap[key];
    };
}
